"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[12104],{

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S$": function() { return /* reexport */ confirmation; },
  "J7": function() { return /* reexport */ debt_ratio; },
  "g0": function() { return /* reexport */ PaymentLeverage_leverage; },
  "B7": function() { return /* reexport */ onboarding; },
  "md": function() { return /* reexport */ terms_conditions; },
  "TI": function() { return /* reexport */ DayTradeUnavailable; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/lib/analytics/securities.ts
var securities = __webpack_require__(91154);
// EXTERNAL MODULE: ./src/global/Securities/components/Modal/BaseSecuritiesModal/index.tsx + 1 modules
var BaseSecuritiesModal = __webpack_require__(48871);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/Onboarding/onboarding.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px 40px 40px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 48px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  gap: 12px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 32px;\n  margin: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 19px;\n  margin: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 40px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  cursor: pointer;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #00ab6b;\n  color: #00ab6b;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13f62da7-0"
})(_templateObject());
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13f62da7-1"
})(_templateObject1());
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-13f62da7-2"
})(_templateObject2());
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-13f62da7-3"
})(_templateObject3());
var ActionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13f62da7-4"
})(_templateObject4());
var NextButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-13f62da7-5"
})(_templateObject5());
var CancelButton = (0,styled_components_browser_esm/* default */.ZP)(NextButton).withConfig({
    componentId: "sc-13f62da7-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/Onboarding/onboarding.tsx









var DayTradeOnboarding = function(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var handleSubmit = function() {
        onSubmit();
        (0,securities/* clevertapDayTradeActivationSelected */.lH)();
    };
    var handleCancel = function(e) {
        onCancel(e);
        (0,securities/* clevertapDayTradeActivationDismissed */.HR)();
    };
    (0,react.useEffect)(function() {
        (0,securities/* clevertapDayTradeActivationViewed */.V8)();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        hideSubmit: true,
        onCancel: handleCancel
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/images/day-trade/onboarding.svg",
                    alt: "Day Trade Onboarding"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: "Day Trade"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                            children: "Tingkatkan daya beli hingga 5 kali lipat trading balance kamu dengan fitur Day Trade."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextButton, {
                            onClick: handleSubmit,
                            type: "primary",
                            children: "Aktifkan Sekarang"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelButton, {
                            onClick: handleCancel,
                            children: "Nanti Aja"
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var onboarding = (DayTradeOnboarding);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/Securities/components/Checkbox/index.tsx
var Checkbox = __webpack_require__(19254);
// EXTERNAL MODULE: ./src/global/Securities/stores/useTermsAndConditionStore.ts + 1 modules
var useTermsAndConditionStore = __webpack_require__(49365);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/global/Securities/types/termsAndCondition.ts
var termsAndCondition = __webpack_require__(13114);
// EXTERNAL MODULE: ./src/features/transaction/useTradingStore.ts
var useTradingStore = __webpack_require__(93918);
;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/OnboardingAcceptTnC/terms-condition.styled.ts

function terms_condition_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n  min-height: 408px;\n"
    ]);
    terms_condition_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function terms_condition_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n  gap: 8px;\n"
    ]);
    terms_condition_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function terms_condition_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & span {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n  }\n  margin: 0;\n"
    ]);
    terms_condition_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function terms_condition_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #ededed;\n  border-radius: 4px;\n"
    ]);
    terms_condition_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function terms_condition_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  border-radius: 4px;\n  width: 100%;\n  height: 408px;\n"
    ]);
    terms_condition_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function terms_condition_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n\n  & span {\n    color: #00ab6b;\n    font-weight: 700;\n    cursor: pointer;\n  }\n"
    ]);
    terms_condition_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function terms_condition_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 20px 0 0;\n"
    ]);
    terms_condition_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 40px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  cursor: pointer;\n\n  &:disabled {\n    background-color: #cceee1 !important;\n    color: #ffffff !important;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var terms_condition_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a5778e9-0"
})(terms_condition_styled_templateObject());
var AgreementWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a5778e9-1"
})(terms_condition_styled_templateObject1());
var AgreementLabel = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4a5778e9-2"
})(terms_condition_styled_templateObject2());
var TnCFrameWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a5778e9-3"
})(terms_condition_styled_templateObject3());
var TnCFrame = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
    componentId: "sc-4a5778e9-4"
})(terms_condition_styled_templateObject4());
var AgreementTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a5778e9-5"
})(terms_condition_styled_templateObject5());
var terms_condition_styled_ActionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a5778e9-6"
})(terms_condition_styled_templateObject6());
var terms_condition_styled_NextButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-4a5778e9-7"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/OnboardingAcceptTnC/terms-conditions.tsx
















var TITLE = "Syarat & Ketentuan Day Trade dan Trading Limit";
var DayTradeTncModal = function(_param) {
    var _title = _param.title, title = _title === void 0 ? TITLE : _title, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "onSubmit",
        "onCancel"
    ]);
    var ref = (0,react.useState)(false), tncAgreed = ref[0], setTncAgreed = ref[1];
    var ref1 = (0,react.useState)(""), tncUrl = ref1[0], setTncUrl = ref1[1];
    var isSubmitting = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.isSubmitting;
    });
    var termsData = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.termsData;
    });
    var postAcceptances = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.postAcceptances;
    });
    var setUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.setUIValue;
    });
    var onSubmitDayTradeTnC = (0,useTradingStore/* default */.Z)(function(s) {
        return s.onSubmitDayTradeTnC;
    });
    var FEATURE_ID = termsAndCondition/* TnCFeaturesIDEnum.DAY_TRADE */.el.DAY_TRADE;
    var terms = termsData === null || termsData === void 0 ? void 0 : termsData[FEATURE_ID];
    var isButtonDisabled = !tncAgreed || isSubmitting;
    var handleCheckboxChange = function(event) {
        setTncAgreed(event.target.checked);
    };
    var handleTncSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var acceptanceLetters;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (tncAgreed) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        acceptanceLetters = Object.keys(termsData).map(function(key) {
                            return {
                                feature_id: key,
                                is_accepted: true,
                                version: termsData[key].version
                            };
                        });
                        _ctx.next = 5;
                        return postAcceptances(acceptanceLetters).then(function(data) {
                            if (data) {
                                setUIValue("dayTradeTnc", true);
                                setUIValue("dayTradeSubAccountActive", true);
                                onSubmitDayTradeTnC === null || onSubmitDayTradeTnC === void 0 ? void 0 : onSubmitDayTradeTnC();
                                onSubmit();
                            }
                        });
                    case 5:
                        (0,securities/* clevertapDayTradeActivationSubmitted */.pl)();
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleTncSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleScrollTo = function(target) {
        var cleanUrl = tncUrl.split("#")[0];
        setTncUrl("".concat(cleanUrl, "#"));
        setTimeout(function() {
            setTncUrl("".concat(cleanUrl, "#").concat(target));
        });
    };
    var handleClickDayTrade = function() {
        handleScrollTo("tnc-day-trade");
    };
    var handleClickTradingLimit = function() {
        handleScrollTo("tnc-trading-limit");
    };
    var renderClickableText = function(text, onClick) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            onClick: onClick,
            "aria-hidden": true,
            children: text
        });
    };
    (0,react.useEffect)(function() {
        if (terms === null || terms === void 0 ? void 0 : terms.url) {
            setTncUrl(terms.url);
        }
    }, [
        terms,
        setTncUrl
    ]);
    (0,react.useEffect)(function() {
        (0,securities/* clevertapDayTradeTNCViewed */.C5)();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        onCancel: onCancel
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(terms_condition_styled_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCFrameWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: tncUrl,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCFrame, {
                            title: "day-trade-tnc",
                            src: tncUrl,
                            id: "tnc-frame"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AgreementWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            onChange: handleCheckboxChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AgreementTextWrapper, {
                            children: [
                                "Saya menyetujui Syarat & Ketentuan Penggunaan",
                                " ",
                                renderClickableText("Day Trade", handleClickDayTrade),
                                " dan",
                                " ",
                                renderClickableText("Trading Limit", handleClickTradingLimit),
                                " di atas."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(terms_condition_styled_ActionWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(terms_condition_styled_NextButton, {
                        onClick: handleTncSubmit,
                        type: "primary",
                        disabled: isButtonDisabled,
                        loading: isSubmitting,
                        children: "Lanjut"
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var terms_conditions = (DayTradeTncModal);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./src/features/day-trade/components/Icons/index.ts + 6 modules
var Icons = __webpack_require__(40892);
;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/OnboardingConfirmation/confirmation.styled.ts

function confirmation_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    confirmation_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function confirmation_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  gap: 12px;\n  padding: 0 16px 16px;\n"
    ]);
    confirmation_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function confirmation_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  margin: 0;\n"
    ]);
    confirmation_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function confirmation_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 19px;\n  margin: 0;\n  width: 70%;\n\n  span svg {\n    margin-top: -2px;\n    color: #8277f8;\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    confirmation_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function confirmation_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n"
    ]);
    confirmation_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function confirmation_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 40px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  cursor: pointer;\n"
    ]);
    confirmation_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var confirmation_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-be749860-0"
})(confirmation_styled_templateObject());
var confirmation_styled_ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-be749860-1"
})(confirmation_styled_templateObject1());
var confirmation_styled_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-be749860-2"
})(confirmation_styled_templateObject2());
var confirmation_styled_Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-be749860-3"
})(confirmation_styled_templateObject3());
var confirmation_styled_ActionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-be749860-4"
})(confirmation_styled_templateObject4());
var FinishButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-be749860-5"
})(confirmation_styled_templateObject5());

;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/OnboardingConfirmation/confirmation.tsx











var DayTradeConfirmation = function(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var handleSubmit = function() {
        onSubmit();
        (0,securities/* clevertapDayTradeActivationSuccessSelected */.p)();
    };
    (0,react.useEffect)(function() {
        (0,securities/* clevertapDayTradeActivationSuccessViewed */.xs)();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        closable: false,
        modalWidth: 415,
        onCancel: onCancel,
        hideSubmit: true
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(confirmation_styled_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(confirmation_styled_ContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/images/day-trade/confirmation-success.svg",
                            alt: "Day Trade Success",
                            height: "120",
                            width: "160"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(confirmation_styled_Title, {
                            children: "Day Trade Berhasil Diaktifkan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(confirmation_styled_Description, {
                            children: [
                                "Kamu sudah bisa melakukan Day Trade di semua saham yang memiliki simbol",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        component: Icons/* LightningBoxSvg */.iD
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(confirmation_styled_ActionWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FinishButton, {
                        onClick: handleSubmit,
                        type: "primary",
                        children: "Selesai"
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var confirmation = (DayTradeConfirmation);

// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/global/Securities/stores/useTradingInfoStore.ts + 1 modules
var useTradingInfoStore = __webpack_require__(21734);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/features/day-trade/utils/formater.ts
var formater = __webpack_require__(22733);
// EXTERNAL MODULE: ./src/features/day-trade/utils/common.ts
var common = __webpack_require__(99533);
// EXTERNAL MODULE: ./src/global/Securities/types/trading.ts
var types_trading = __webpack_require__(6421);
;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/OrderUnavailable/unavailable.styled.ts

function unavailable_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  gap: 20px;\n"
    ]);
    unavailable_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function unavailable_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  width: 90%;\n  margin: 0;\n"
    ]);
    unavailable_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function unavailable_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    unavailable_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function unavailable_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 40px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  cursor: pointer;\n"
    ]);
    unavailable_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var unavailable_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4acb3710-0"
})(unavailable_styled_templateObject());
var unavailable_styled_Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4acb3710-1"
})(unavailable_styled_templateObject1());
var unavailable_styled_ActionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4acb3710-2"
})(unavailable_styled_templateObject2());
var ConfirmButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-4acb3710-3"
})(unavailable_styled_templateObject3());

;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/OrderUnavailable/unavailable.tsx















function DayTradeUnavailable(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var ref = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return s.dayTrade;
    }), eventType = ref.event_type, tradingOpen = ref.trading_open, tradingClose = ref.trading_close;
    var orderType = (0,store/* default */.Z)().orderType;
    var SELL = trading/* ORDER_TYPE.SELL */.Jm.SELL, AMEND_SELL = trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL;
    var isTimeLimit = eventType === types_trading/* EventTypeEnum.OUTSIDE_MARKET_HOURS */.by.OUTSIDE_MARKET_HOURS;
    var isSellOrder = orderType === SELL || orderType === AMEND_SELL;
    var isSellAmend = orderType === AMEND_SELL;
    var formattedTime = (0,formater/* formatHourMinutes */.d7)(tradingOpen, tradingClose).openClose;
    var imageUrl = isTimeLimit ? "time-limit" : "force-selling";
    var unavailableReason = (0,common/* getUnavailableReason */.bs)(isTimeLimit, isSellOrder, isSellAmend, formattedTime);
    var handleSubmit = function() {
        onSubmit();
        if (!isTimeLimit || isSellAmend) {
            (0,securities/* clevertapDayTradeDebtRatioSubmitted */.SW)();
        }
    };
    (0,react.useEffect)(function() {
        if (isTimeLimit && !isSellAmend) {
            (0,securities/* clevertapDayTradeAfterMarketViewed */.jS)();
        } else {
            (0,securities/* clevertapDayTradeDebtRatioViewed */.L)();
        }
    }, [
        isTimeLimit,
        isSellAmend
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onCancel: onCancel,
        hideSubmit: true,
        closable: false,
        modalWidth: 415
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(unavailable_styled_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/images/day-trade/unavailable-".concat(imageUrl, ".svg"),
                    alt: "Day Trade Unavailable",
                    height: 120
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(unavailable_styled_Description, {
                    children: unavailableReason
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(unavailable_styled_ActionWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmButton, {
                        onClick: handleSubmit,
                        type: "primary",
                        children: "Oke"
                    })
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var Common_If = __webpack_require__(3897);
// EXTERNAL MODULE: ./src/global/Securities/types/transaction.ts
var transaction = __webpack_require__(2078);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 4 modules
var es_radio = __webpack_require__(29924);
;// CONCATENATED MODULE: ./src/global/Securities/components/Radio/index.ts

function Radio_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & span.ant-radio-inner::after {\n    top: 50%;\n    left: 50%;\n    width: 11px;\n    height: 11px;\n    transform: translate(-50%, -50%);\n  }\n"
    ]);
    Radio_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Radio = (0,styled_components_browser_esm/* default */.ZP)(es_radio/* default */.ZP).withConfig({
    componentId: "sc-2997eda8-0"
})(Radio_templateObject());
/* harmony default export */ var components_Radio = (Radio);

// EXTERNAL MODULE: ./src/global/Securities/components/Chips/index.tsx
var Chips = __webpack_require__(17348);
// EXTERNAL MODULE: ./src/global/Securities/components/SkeletonWrapper/index.tsx
var SkeletonWrapper = __webpack_require__(27607);
;// CONCATENATED MODULE: ./src/global/Securities/components/Icons/ReloadSvg.tsx

var ReloadSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 12 13",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M9.967 7.02a4 4 0 11-4.963-4.393c1.95-.5 3.968.503 4.713 2.373"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#00AB6B",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M10 2.5V5H7.5"
            })
        ]
    });
};
/* harmony default export */ var Icons_ReloadSvg = (ReloadSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/constants/leverage.ts
var TRADING_LIMIT = {
    description: "Kamu bisa menyimpan posisi leverage maksimal hingga T+3 setelah tanggal transaksi. Biaya harian sebesar 0.10% akan berlaku mulai dari T+3. Aturan Forced Sell akan diberlakukan pada T+4."
};
var DAY_TRADE = {
    description: "Kamu harus menjual semua posisi day trade pada pukul %CLOSE_TIME% WIB di hari trading yang sama. Tidak ada biaya tambahan berlaku."
};
var DAY_TRADE_UNAVAILBALE_REASON = {
    OUTSIDE_MARKET_HOURS: "Pembelian saham-saham Day Trade dapat dilakukan di hari bursa sampai pukul %CLOSE_TIME% WIB. Day Trade akan tersedia kembali pada hari bursa mulai pukul %OPEN_TIME% WIB.",
    EXCEED_DEBT_RATIO: "Debt Ratio kamu sudah mencapai limit. Silakan melakukan penjualan aset atau menunggu hingga proses forced sell selesai.",
    MAX_DEBT_LIMIT: "Kamu sudah menggunakan seluruh kuota Day Trade kamu. Jual sebagian saham kamu untuk menggunakan Day Trade kembali",
    ZERO_BALANCE: "Saldo kamu tidak mencukupi untuk melakukan pembelian dengan menggunakan Day Trade."
};
/* harmony default export */ var leverage = ({
    TRADING_LIMIT: TRADING_LIMIT,
    DAY_TRADE: DAY_TRADE,
    DAY_TRADE_UNAVAILBALE_REASON: DAY_TRADE_UNAVAILBALE_REASON
});

// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/global/Securities/stores/useCashInfoStore.ts
var useCashInfoStore = __webpack_require__(11806);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
// EXTERNAL MODULE: ./src/features/search/styled.ts
var styled = __webpack_require__(14348);
;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/PaymentLeverage/leverage.styled.ts

function leverage_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: 18px;\n  font-weight: 700;\n  color: #333333;\n  margin: 0 0 20px;\n"
    ]);
    leverage_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 16px 20px;\n  gap: 16px;\n\n  & > button {\n    padding: 16px;\n    border: 1px solid #f1f1f1;\n    border-radius: 6px;\n    gap: 16px;\n  }\n"
    ]);
    leverage_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: none;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n\n  text-align: left;\n  cursor: pointer;\n\n  & > .ant-radio-wrapper {\n    display: block;\n    margin: 0;\n  }\n\n  .activate-daytrade {\n    color: #00ab6b;\n  }\n\n  .disabled-daytrade {\n    color: #b5b5b5;\n  }\n\n  :disabled {\n    cursor: not-allowed;\n  }\n"
    ]);
    leverage_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n"
    ]);
    leverage_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    leverage_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & span.ant-skeleton-button {\n    width: 100px;\n    height: 22px;\n  }\n"
    ]);
    leverage_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin: 0 0 4px;\n\n  & > div,\n  button {\n    margin-left: 8px;\n  }\n\n  .multiplier-chip {\n    font-size: 14px;\n    line-height: 19px;\n    border-color: #f2f1fe;\n    background-color: #f2f1fe;\n    color: #8277f8;\n    padding: 2px 8px;\n    display: flex;\n    gap: 2px;\n  }\n"
    ]);
    leverage_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n  color: #333333;\n\n  margin: 0;\n\n  ",
        "\n"
    ]);
    leverage_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  color: #969696;\n\n  margin: 0;\n  width: 88%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  width: 100%;\n  max-width: 460px;\n  font-size: 14px;\n  color: #333333;\n  cursor: default;\n  gap: 8px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n\n  span {\n    font-weight: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 0;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 10px 0;\n  width: 50%;\n  min-width: unset;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  padding: 0 6px;\n  border-radius: 8px;\n  border: 1px solid #f2f1fe;\n  height: 18px;\n  background-color: #f2f1fe;\n  color: #8277f8;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  .multiplier-chip {\n    font-size: 14px;\n    line-height: 19px;\n    border-color: #f2f1fe;\n    background-color: #f2f1fe;\n    color: #8277f8;\n    padding: 2px 8px;\n    display: flex;\n    gap: 2px;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & span.ant-skeleton-button {\n    width: 60px;\n    height: 22px;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & span.ant-skeleton-button {\n    width: 100px;\n    height: 22px;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}



var leverage_styled_Title = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-41b6b08-0"
})(leverage_styled_templateObject());
var MethodGroup = (0,styled_components_browser_esm/* default */.ZP)(styled/* RadioGroup */.Ee).withConfig({
    componentId: "sc-41b6b08-1"
})(leverage_styled_templateObject1());
var MethodItem = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-41b6b08-2"
})(leverage_styled_templateObject2());
var MethodItemButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41b6b08-3"
})(leverage_styled_templateObject3());
var MethodTextContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41b6b08-4"
})(leverage_styled_templateObject4());
var MethodTitleSkeleton = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default.Button */.Z.Button).withConfig({
    componentId: "sc-41b6b08-5"
})(leverage_styled_templateObject5());
var MethodTitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41b6b08-6"
})(leverage_styled_templateObject6());
var MethodTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-41b6b08-7"
})(leverage_styled_templateObject7(), function(param) {
    var disabled = param.disabled;
    return disabled && "\n    color: #B5B5B5;\n  ";
});
var MethodDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-41b6b08-8"
})(_templateObject8());
var ChipsButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-41b6b08-9"
})(_templateObject9());
var LeverageInfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41b6b08-10"
})(_templateObject10());
var InfoRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41b6b08-11"
})(_templateObject11(), function(param) {
    var isBold = param.isBold;
    return isBold ? "700" : "400";
});
var DividerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41b6b08-12"
})(_templateObject12());
var RowDivider = (0,styled_components_browser_esm/* default */.ZP)(divider/* default */.Z).withConfig({
    componentId: "sc-41b6b08-13"
})(_templateObject13());
var SymbolChip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41b6b08-14"
})(_templateObject14());
var BuyingPowerWording = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-41b6b08-15"
})(_templateObject15());
var ChipSkeleton = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default.Button */.Z.Button).withConfig({
    componentId: "sc-41b6b08-16"
})(_templateObject16());
var PriceSkeleton = (0,styled_components_browser_esm/* default */.ZP)(ChipSkeleton).withConfig({
    componentId: "sc-41b6b08-17"
})(_templateObject17());

;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/PaymentLeverage/leverage-info.tsx











var LeverageInfo = function(param) {
    var multiplier = param.multiplier;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useCashInfoStore/* default */.Z)(function(s) {
        return [
            s.error,
            s.isLoading,
            s.dayTrade,
            s.dayTradeLeverage,
            s.dayTradeTradingBalance, 
        ];
    }, shallow/* default */.Z), 5), cashInfoError = ref[0], isCashInfoLoading = ref[1], dayTradeBuyingPower = ref[2], dayTradeLeverage = ref[3], dayTradeTradingBalance = ref[4];
    var getBalance = function(balance) {
        return "Rp".concat(numeral_default()(Math.floor(balance)).format("0,00"));
    };
    if (cashInfoError) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeverageInfoWrapper, {
        onClick: function(e) {
            return e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Trading Balance"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                        skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceSkeleton, {
                            active: true
                        }),
                        loading: isCashInfoLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: getBalance(dayTradeTradingBalance)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DividerWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowDivider, {
                        dashed: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SymbolChip, {
                        children: "+"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowDivider, {
                        dashed: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Leverage"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                        skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceSkeleton, {
                            active: true
                        }),
                        loading: isCashInfoLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: getBalance(dayTradeLeverage)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DividerWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowDivider, {
                        dashed: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SymbolChip, {
                        children: "="
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowDivider, {
                        dashed: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoRow, {
                isBold: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuyingPowerWording, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Buying Power"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                                skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipSkeleton, {
                                    active: true
                                }),
                                loading: isCashInfoLoading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chips/* default */.Z, {
                                    className: "multiplier-chip",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            component: Icons/* LightningSvg */.Sf
                                        }),
                                        "".concat(multiplier, "x")
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                        skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceSkeleton, {
                            active: true
                        }),
                        loading: isCashInfoLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: getBalance(dayTradeBuyingPower)
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var leverage_info = (/*#__PURE__*/(0,react.memo)(LeverageInfo));

;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/PaymentLeverage/leverage.tsx
























var defaultMethodList = {
    TradingLimit: {
        title: "Trading Limit",
        description: leverage.TRADING_LIMIT.description
    },
    DayTrade: {
        title: "Day Trade",
        description: leverage.DAY_TRADE.description
    }
};
var _obj;
var defaultBalance = (_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit, 0), (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.DayTrade */.XL.DayTrade, 0), _obj);
var PaymentMethodModal = function(_param) {
    var _title = _param.title, title = _title === void 0 ? "Leverage" : _title, _balance = _param.balance, balance = _balance === void 0 ? defaultBalance : _balance, _methodList = _param.methodList, methodList = _methodList === void 0 ? defaultMethodList : _methodList, methodValue = _param.methodValue, defaultMethodValue = _param.defaultMethodValue, _tradingBalance = _param.tradingBalance, tradingBalance = _tradingBalance === void 0 ? 0 : _tradingBalance, _loading = _param.loading, loading = _loading === void 0 ? false : _loading, _symbol = _param.symbol, symbol = _symbol === void 0 ? "" : _symbol, _error = _param.error, error = _error === void 0 ? {} : _error, _splitOrderActive = _param.splitOrderActive, splitOrderActive = _splitOrderActive === void 0 ? false : _splitOrderActive, _dayTradeAvailable = _param.dayTradeAvailable, dayTradeAvailable = _dayTradeAvailable === void 0 ? false : _dayTradeAvailable, _dayTradeMultiplier = _param.dayTradeMultiplier, dayTradeMultiplier = _dayTradeMultiplier === void 0 ? 0 : _dayTradeMultiplier, _onMethodChange = _param.onMethodChange, onMethodChange = _onMethodChange === void 0 ? function() {} : _onMethodChange, _onReloadClick = _param.onReloadClick, onReloadClick = _onReloadClick === void 0 ? function() {} : _onReloadClick, _onShowDayTradeOnboarding = _param.onShowDayTradeOnboarding, onShowDayTradeOnboarding = _onShowDayTradeOnboarding === void 0 ? function() {} : _onShowDayTradeOnboarding, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "balance",
        "methodList",
        "methodValue",
        "defaultMethodValue",
        "tradingBalance",
        "loading",
        "symbol",
        "error",
        "splitOrderActive",
        "dayTradeAvailable",
        "dayTradeMultiplier",
        "onMethodChange",
        "onReloadClick",
        "onShowDayTradeOnboarding"
    ]);
    var ref = (0,react.useState)(defaultMethodValue), selectedMethod = ref[0], setSelectedMethod = ref[1];
    var ref1 = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return {
            dayTrade: s.dayTrade,
            loadTradingInfo: s.loadTradingInfo
        };
    }), dayTrade = ref1.dayTrade, loadTradingInfo = ref1.loadTradingInfo;
    var ref2 = dayTrade || {}, eventType = ref2.event_type;
    var handleMethodClick = function(method) {
        if (loading || error[method]) return;
        setSelectedMethod(method);
        onMethodChange(method);
        (0,securities/* clevertapSetVisibleBalance */.ng)();
    };
    var handleReloadClick = function(event) {
        event.stopPropagation();
        onReloadClick();
    };
    var handleOpenDayTradeActivation = function() {
        onShowDayTradeOnboarding();
        (0,securities/* clevertapDayTradeLeverageActivationSelected */.oZ)();
    };
    var isDayTradeNotTradable = [
        types_trading/* EventTypeEnum.OUTSIDE_MARKET_HOURS */.by.OUTSIDE_MARKET_HOURS,
        types_trading/* EventTypeEnum.EXCEED_DEBT_RATIO */.by.EXCEED_DEBT_RATIO, 
    ].includes(eventType);
    var getChipButton = function(methodType) {
        var isDayTrade = methodType === transaction/* PaymentMethod.DayTrade */.XL.DayTrade;
        if (isDayTrade && (isDayTradeNotTradable || tradingBalance <= 0)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chips/* default */.Z, {
                className: "disabled-daytrade",
                children: "Tidak Tersedia"
            });
        }
        var disabledChipsClassName = isDayTrade && balance[methodType] <= 0 ? "disabled-daytrade" : "";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chips/* default */.Z, {
            "data-cy": "".concat(methodType, "-balance"),
            className: disabledChipsClassName,
            children: "Rp".concat(numeral_default()(Math.floor(balance[methodType])).format("0,00"))
        });
    };
    var getDefaultDescription = function(description) {
        var isDayTrade = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        if (!isDayTrade) return description;
        var hourMinute = (0,formater/* formatHourMinutes */.d7)(dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.trading_open, dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.trading_close);
        return (0,formater/* replaceWords */.Wn)(description, [
            "%CLOSE_TIME%"
        ], [
            hourMinute.close
        ]);
    };
    var getDayTradeDescription = function(daytradeBalance) {
        if (tradingBalance <= 0) {
            return leverage.DAY_TRADE_UNAVAILBALE_REASON.ZERO_BALANCE;
        }
        if (eventType === types_trading/* EventTypeEnum.OUTSIDE_MARKET_HOURS */.by.OUTSIDE_MARKET_HOURS) {
            var hourMinute = (0,formater/* formatHourMinutes */.d7)(dayTrade.trading_open, dayTrade.trading_close);
            return (0,formater/* replaceWords */.Wn)(leverage.DAY_TRADE_UNAVAILBALE_REASON.OUTSIDE_MARKET_HOURS, [
                "%CLOSE_TIME%",
                "%OPEN_TIME%"
            ], [
                hourMinute.close,
                hourMinute.open
            ]);
        }
        if (eventType === types_trading/* EventTypeEnum.EXCEED_DEBT_RATIO */.by.EXCEED_DEBT_RATIO) {
            return leverage.DAY_TRADE_UNAVAILBALE_REASON.EXCEED_DEBT_RATIO;
        }
        if (daytradeBalance <= 0) {
            return leverage.DAY_TRADE_UNAVAILBALE_REASON.MAX_DEBT_LIMIT;
        }
        return getDefaultDescription(defaultMethodList.DayTrade.description);
    };
    // Only get trading info if day trade is available
    (0,react.useEffect)(function() {
        if (dayTradeAvailable && props.visible) {
            loadTradingInfo([
                types_trading/* TradingFeatureEnum.DAY_TRADE */.n5.DAY_TRADE
            ]);
        }
    }, [
        dayTradeAvailable,
        props.visible,
        loadTradingInfo
    ]);
    (0,react.useEffect)(function() {
        if (props.visible) (0,securities/* clevertapDayTradeLeverageOptionViewed */.Nf)();
    }, [
        props.visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        hideSubmit: true
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MethodGroup, {
            value: methodValue || selectedMethod,
            children: Object.entries(methodList).map(function(param) {
                var _$_param = (0,_sliced_to_array/* default */.Z)(param, 2), methodType = _$_param[0], methodConfig = _$_param[1];
                if (balance[methodType] === undefined) return null;
                var isErrorOrLoading = loading || error[methodType];
                var isDayTrade = methodType === transaction/* PaymentMethod.DayTrade */.XL.DayTrade;
                var isDayTradeAvailable = isDayTrade && dayTradeAvailable;
                var isDayTradeNotAvailable = isDayTrade && !dayTradeAvailable;
                var isDayTradeSplitOrderActive = isDayTrade && splitOrderActive;
                var isDayTradeExceedLimit = isDayTrade && balance[methodType] <= 0;
                var isDayTradeExceedLimitAndNotAvailable = isDayTrade && eventType === types_trading/* EventTypeEnum.EXCEED_DEBT_RATIO */.by.EXCEED_DEBT_RATIO;
                var isDayTradeOutsideMarketHours = isDayTrade && eventType === types_trading/* EventTypeEnum.OUTSIDE_MARKET_HOURS */.by.OUTSIDE_MARKET_HOURS;
                var isDisabledSelect = isErrorOrLoading || isDayTradeNotAvailable || isDayTradeSplitOrderActive || isDayTradeExceedLimit || isDayTradeExceedLimitAndNotAvailable || isDayTradeOutsideMarketHours;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MethodItem, {
                    "data-cy": "".concat(methodType, "-button"),
                    onClick: function() {
                        if (isDayTradeNotAvailable || isErrorOrLoading) {
                            return;
                        }
                        handleMethodClick(methodType);
                    },
                    disabled: isDisabledSelect && dayTradeAvailable,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MethodItemButton, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MethodTextContent, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MethodTitleWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MethodTitle, {
                                                    disabled: isDisabledSelect && dayTradeAvailable,
                                                    children: methodConfig.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                                                    condition: isDayTrade && dayTradeMultiplier > 0 && (!isDisabledSelect || !isDayTradeAvailable),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chips/* default */.Z, {
                                                        "data-cy": "day-trade-multiplier",
                                                        className: "multiplier-chip",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                                component: Icons/* LightningSvg */.Sf
                                                            }),
                                                            "".concat(dayTradeMultiplier, "x")
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                                                    skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(MethodTitleSkeleton, {
                                                        active: true
                                                    }),
                                                    loading: loading,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                                                        condition: !isDayTrade || isDayTradeAvailable,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Common_If/* default */.Z, {
                                                            condition: error[methodType] && !isDayTrade,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipsButton, {
                                                                    onClick: handleReloadClick,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chips/* default */.Z, {
                                                                        style: {
                                                                            color: "#00AB6B"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                                                component: Icons_ReloadSvg,
                                                                                style: {
                                                                                    marginRight: 4
                                                                                }
                                                                            }),
                                                                            "Muat Ulang"
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default.Else */.Z.Else, {
                                                                    children: getChipButton(methodType)
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MethodDescription, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Common_If/* default */.Z, {
                                                condition: isDayTradeNotAvailable,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            "Gunakan Day Trade dan dapatkan tambahan",
                                                            " ",
                                                            dayTradeMultiplier,
                                                            "x Buying Power saham ",
                                                            symbol,
                                                            "."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default.Else */.Z.Else, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Common_If/* default */.Z, {
                                                            condition: !isDisabledSelect,
                                                            children: [
                                                                getDefaultDescription(methodConfig.description, isDayTrade),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default.Else */.Z.Else, {
                                                                    children: getDayTradeDescription(balance[methodType])
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Common_If/* default */.Z, {
                                    condition: isDayTradeNotAvailable && !dayTradeAvailable,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Chips/* default */.Z, {
                                            className: "activate-daytrade",
                                            onClick: handleOpenDayTradeActivation,
                                            children: "Aktifkan"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default.Else */.Z.Else, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Radio, {
                                                value: methodType,
                                                disabled: isDisabledSelect
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                            condition: isDayTrade && isDayTradeAvailable && !isDayTradeNotTradable && balance[methodType] > 0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(leverage_info, {
                                multiplier: dayTradeMultiplier
                            })
                        })
                    ]
                }, methodType);
            })
        })
    }));
};
/* harmony default export */ var PaymentLeverage_leverage = (PaymentMethodModal);

// EXTERNAL MODULE: ./node_modules/lottie-web/build/player/lottie.js
var lottie = __webpack_require__(11248);
var lottie_default = /*#__PURE__*/__webpack_require__.n(lottie);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
;// CONCATENATED MODULE: ./public/animation/speedo-portfolio.json
var speedo_portfolio_namespaceObject = JSON.parse('{"v":"5.9.6","fr":50,"ip":0,"op":150,"w":1230,"h":615,"nm":"Speedo","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Ellipse 1350 (Stroke)","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[615,313,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-0.157,0],[-0.157,-0.001],[0,0],[0.168,0],[0.168,-0.001]],"o":[[0.157,-0.001],[0.157,0],[0,0],[-0.168,-0.001],[-0.168,0],[0,0]],"v":[[-0.472,-52.999],[0,-53],[0.472,-52.999],[0.505,-60.999],[0,-61],[-0.505,-60.999]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[-0.314,0.012],[0,0],[0.336,-0.015]],"o":[[0.314,-0.014],[0,0],[-0.336,0.012],[0,0]],"v":[[-5.182,-52.882],[-4.241,-52.921],[-4.538,-60.916],[-5.546,-60.874]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ind":2,"ty":"sh","ix":3,"ks":{"a":0,"k":{"i":[[0,0],[-0.314,-0.014],[0,0],[0.336,0.012]],"o":[[0.314,0.012],[0,0],[-0.336,-0.015],[0,0]],"v":[[4.241,-52.921],[5.182,-52.882],[5.546,-60.874],[4.538,-60.916]],"c":true},"ix":2},"nm":"Path 3","mn":"ADBE Vector Shape - Group","hd":false},{"ind":3,"ty":"sh","ix":4,"ks":{"a":0,"k":{"i":[[0,0],[-0.313,0.025],[0,0],[0.335,-0.029]],"o":[[0.313,-0.027],[0,0],[-0.335,0.026],[0,0]],"v":[[-9.884,-52.571],[-8.945,-52.649],[-9.572,-60.624],[-10.578,-60.541]],"c":true},"ix":2},"nm":"Path 4","mn":"ADBE Vector Shape - Group","hd":false},{"ind":4,"ty":"sh","ix":5,"ks":{"a":0,"k":{"i":[[0,0],[-0.313,-0.027],[0,0],[0.335,0.026]],"o":[[0.313,0.025],[0,0],[-0.335,-0.029],[0,0]],"v":[[8.945,-52.649],[9.884,-52.571],[10.578,-60.541],[9.572,-60.624]],"c":true},"ix":2},"nm":"Path 5","mn":"ADBE Vector Shape - Group","hd":false},{"ind":5,"ty":"sh","ix":6,"ks":{"a":0,"k":{"i":[[0,0],[-0.312,0.038],[0,0],[0.333,-0.043]],"o":[[0.312,-0.04],[0,0],[-0.334,0.04],[0,0]],"v":[[-14.569,-52.066],[-13.634,-52.182],[-14.59,-60.125],[-15.591,-60]],"c":true},"ix":2},"nm":"Path 6","mn":"ADBE Vector Shape - Group","hd":false},{"ind":6,"ty":"sh","ix":7,"ks":{"a":0,"k":{"i":[[0,0],[-0.311,-0.04],[0,0],[0.334,0.04]],"o":[[0.312,0.038],[0,0],[-0.333,-0.043],[0,0]],"v":[[13.634,-52.182],[14.569,-52.066],[15.591,-60],[14.59,-60.125]],"c":true},"ix":2},"nm":"Path 7","mn":"ADBE Vector Shape - Group","hd":false},{"ind":7,"ty":"sh","ix":8,"ks":{"a":0,"k":{"i":[[0,0],[-0.31,0.05],[0,0],[0.331,-0.057]],"o":[[0.31,-0.053],[0,0],[-0.332,0.054],[0,0]],"v":[[-19.229,-51.367],[-18.299,-51.522],[-19.584,-59.418],[-20.578,-59.253]],"c":true},"ix":2},"nm":"Path 8","mn":"ADBE Vector Shape - Group","hd":false},{"ind":8,"ty":"sh","ix":9,"ks":{"a":0,"k":{"i":[[0,0],[-0.309,-0.053],[0,0],[0.332,0.054]],"o":[[0.31,0.05],[0,0],[-0.331,-0.057],[0,0]],"v":[[18.299,-51.522],[19.229,-51.367],[20.578,-59.253],[19.584,-59.418]],"c":true},"ix":2},"nm":"Path 9","mn":"ADBE Vector Shape - Group","hd":false},{"ind":9,"ty":"sh","ix":10,"ks":{"a":0,"k":{"i":[[0,0],[-0.308,0.063],[0,0],[0.329,-0.07]],"o":[[0.307,-0.066],[0,0],[-0.329,0.068],[0,0]],"v":[[-23.856,-50.476],[-22.933,-50.67],[-24.543,-58.506],[-25.53,-58.299]],"c":true},"ix":2},"nm":"Path 10","mn":"ADBE Vector Shape - Group","hd":false},{"ind":10,"ty":"sh","ix":11,"ks":{"a":0,"k":{"i":[[0,0],[-0.307,-0.066],[0,0],[0.329,0.068]],"o":[[0.308,0.063],[0,0],[-0.329,-0.07],[0,0]],"v":[[22.933,-50.67],[23.856,-50.476],[25.53,-58.299],[24.543,-58.506]],"c":true},"ix":2},"nm":"Path 11","mn":"ADBE Vector Shape - Group","hd":false},{"ind":11,"ty":"sh","ix":12,"ks":{"a":0,"k":{"i":[[0,0],[-0.305,0.076],[0,0],[0.326,-0.084]],"o":[[0.304,-0.078],[0,0],[-0.326,0.081],[0,0]],"v":[[-28.442,-49.395],[-27.528,-49.627],[-29.46,-57.39],[-30.438,-57.142]],"c":true},"ix":2},"nm":"Path 12","mn":"ADBE Vector Shape - Group","hd":false},{"ind":12,"ty":"sh","ix":13,"ks":{"a":0,"k":{"i":[[0,0],[-0.304,-0.078],[0,0],[0.326,0.081]],"o":[[0.305,0.076],[0,0],[-0.326,-0.084],[0,0]],"v":[[27.528,-49.627],[28.442,-49.395],[30.438,-57.142],[29.46,-57.39]],"c":true},"ix":2},"nm":"Path 13","mn":"ADBE Vector Shape - Group","hd":false},{"ind":13,"ty":"sh","ix":14,"ks":{"a":0,"k":{"i":[[0,0],[-0.301,0.088],[0,0],[0.322,-0.097]],"o":[[0.301,-0.091],[0,0],[-0.323,0.095],[0,0]],"v":[[-32.98,-48.126],[-32.077,-48.394],[-34.328,-56.071],[-35.294,-55.783]],"c":true},"ix":2},"nm":"Path 14","mn":"ADBE Vector Shape - Group","hd":false},{"ind":14,"ty":"sh","ix":15,"ks":{"a":0,"k":{"i":[[0,0],[-0.301,-0.091],[0,0],[0.323,0.095]],"o":[[0.301,0.088],[0,0],[-0.322,-0.097],[0,0]],"v":[[32.077,-48.394],[32.98,-48.126],[35.294,-55.783],[34.328,-56.071]],"c":true},"ix":2},"nm":"Path 15","mn":"ADBE Vector Shape - Group","hd":false},{"ind":15,"ty":"sh","ix":16,"ks":{"a":0,"k":{"i":[[0,0],[-0.298,0.101],[0,0],[0.318,-0.11]],"o":[[0.297,-0.103],[0,0],[-0.318,0.108],[0,0]],"v":[[-37.461,-46.669],[-36.57,-46.975],[-39.136,-54.552],[-40.09,-54.225]],"c":true},"ix":2},"nm":"Path 16","mn":"ADBE Vector Shape - Group","hd":false},{"ind":16,"ty":"sh","ix":17,"ks":{"a":0,"k":{"i":[[0,0],[-0.297,-0.103],[0,0],[0.318,0.108]],"o":[[0.298,0.101],[0,0],[-0.318,-0.11],[0,0]],"v":[[36.57,-46.975],[37.461,-46.669],[40.09,-54.225],[39.136,-54.552]],"c":true},"ix":2},"nm":"Path 17","mn":"ADBE Vector Shape - Group","hd":false},{"ind":17,"ty":"sh","ix":18,"ks":{"a":0,"k":{"i":[[0,0],[-0.293,0.113],[0,0],[0.313,-0.124]],"o":[[0.292,-0.115],[0,0],[-0.314,0.121],[0,0]],"v":[[-41.879,-45.029],[-41.001,-45.372],[-43.878,-52.836],[-44.817,-52.47]],"c":true},"ix":2},"nm":"Path 18","mn":"ADBE Vector Shape - Group","hd":false},{"ind":18,"ty":"sh","ix":19,"ks":{"a":0,"k":{"i":[[0,0],[-0.292,-0.115],[0,0],[0.314,0.121]],"o":[[0.293,0.113],[0,0],[-0.313,-0.124],[0,0]],"v":[[41.001,-45.372],[41.879,-45.029],[44.817,-52.47],[43.878,-52.836]],"c":true},"ix":2},"nm":"Path 19","mn":"ADBE Vector Shape - Group","hd":false},{"ind":19,"ty":"sh","ix":20,"ks":{"a":0,"k":{"i":[[0,0],[-0.288,0.125],[0,0],[0.307,-0.136]],"o":[[0.287,-0.127],[0,0],[-0.308,0.134],[0,0]],"v":[[-46.224,-43.208],[-45.361,-43.587],[-48.545,-50.926],[-49.468,-50.521]],"c":true},"ix":2},"nm":"Path 20","mn":"ADBE Vector Shape - Group","hd":false},{"ind":20,"ty":"sh","ix":21,"ks":{"a":0,"k":{"i":[[0,0],[-0.287,-0.127],[0,0],[0.308,0.134]],"o":[[0.288,0.125],[0,0],[-0.307,-0.136],[0,0]],"v":[[45.361,-43.587],[46.224,-43.208],[49.468,-50.521],[48.545,-50.926]],"c":true},"ix":2},"nm":"Path 21","mn":"ADBE Vector Shape - Group","hd":false},{"ind":21,"ty":"sh","ix":22,"ks":{"a":0,"k":{"i":[[0,0],[-0.283,0.137],[0,0],[0.301,-0.149]],"o":[[0.282,-0.139],[0,0],[-0.303,0.146],[0,0]],"v":[[-50.491,-41.209],[-49.645,-41.623],[-53.128,-48.824],[-54.034,-48.381]],"c":true},"ix":2},"nm":"Path 22","mn":"ADBE Vector Shape - Group","hd":false},{"ind":22,"ty":"sh","ix":23,"ks":{"a":0,"k":{"i":[[0,0],[-0.282,-0.139],[0,0],[0.303,0.146]],"o":[[0.283,0.137],[0,0],[-0.301,-0.149],[0,0]],"v":[[49.645,-41.623],[50.491,-41.209],[54.034,-48.381],[53.128,-48.824]],"c":true},"ix":2},"nm":"Path 23","mn":"ADBE Vector Shape - Group","hd":false},{"ind":23,"ty":"sh","ix":24,"ks":{"a":0,"k":{"i":[[0,0],[-0.277,0.148],[0,0],[0.295,-0.161]],"o":[[0.276,-0.151],[0,0],[-0.296,0.159],[0,0]],"v":[[-54.672,-39.035],[-53.843,-39.484],[-57.622,-46.535],[-58.508,-46.055]],"c":true},"ix":2},"nm":"Path 24","mn":"ADBE Vector Shape - Group","hd":false},{"ind":24,"ty":"sh","ix":25,"ks":{"a":0,"k":{"i":[[0,0],[-0.276,-0.151],[0,0],[0.296,0.159]],"o":[[0.277,0.148],[0,0],[-0.295,-0.161],[0,0]],"v":[[53.843,-39.484],[54.672,-39.035],[58.508,-46.055],[57.622,-46.535]],"c":true},"ix":2},"nm":"Path 25","mn":"ADBE Vector Shape - Group","hd":false},{"ind":25,"ty":"sh","ix":26,"ks":{"a":0,"k":{"i":[[0,0],[-0.271,0.16],[0,0],[0.288,-0.173]],"o":[[0.269,-0.162],[0,0],[-0.29,0.171],[0,0]],"v":[[-58.759,-36.69],[-57.95,-37.173],[-62.016,-44.062],[-62.883,-43.546]],"c":true},"ix":2},"nm":"Path 26","mn":"ADBE Vector Shape - Group","hd":false},{"ind":26,"ty":"sh","ix":27,"ks":{"a":0,"k":{"i":[[0,0],[-0.269,-0.162],[0,0],[0.29,0.171]],"o":[[0.271,0.16],[0,0],[-0.288,-0.173],[0,0]],"v":[[57.95,-37.173],[58.759,-36.69],[62.883,-43.546],[62.016,-44.062]],"c":true},"ix":2},"nm":"Path 27","mn":"ADBE Vector Shape - Group","hd":false},{"ind":27,"ty":"sh","ix":28,"ks":{"a":0,"k":{"i":[[0,0],[-0.264,0.171],[0,0],[0.281,-0.185]],"o":[[0.262,-0.173],[0,0],[-0.282,0.183],[0,0]],"v":[[-62.746,-34.179],[-61.957,-34.694],[-66.305,-41.41],[-67.149,-40.858]],"c":true},"ix":2},"nm":"Path 28","mn":"ADBE Vector Shape - Group","hd":false},{"ind":28,"ty":"sh","ix":29,"ks":{"a":0,"k":{"i":[[0,0],[-0.262,-0.173],[0,0],[0.282,0.183]],"o":[[0.264,0.171],[0,0],[-0.281,-0.185],[0,0]],"v":[[61.957,-34.694],[62.746,-34.179],[67.149,-40.858],[66.305,-41.41]],"c":true},"ix":2},"nm":"Path 29","mn":"ADBE Vector Shape - Group","hd":false},{"ind":29,"ty":"sh","ix":30,"ks":{"a":0,"k":{"i":[[0,0],[-0.256,0.181],[0,0],[0.273,-0.196]],"o":[[0.255,-0.184],[0,0],[-0.274,0.194],[0,0]],"v":[[-66.626,-31.505],[-65.859,-32.052],[-70.48,-38.582],[-71.301,-37.996]],"c":true},"ix":2},"nm":"Path 30","mn":"ADBE Vector Shape - Group","hd":false},{"ind":30,"ty":"sh","ix":31,"ks":{"a":0,"k":{"i":[[0,0],[-0.255,-0.184],[0,0],[0.274,0.194]],"o":[[0.256,0.181],[0,0],[-0.273,-0.196],[0,0]],"v":[[65.859,-32.052],[66.626,-31.505],[71.301,-37.996],[70.48,-38.582]],"c":true},"ix":2},"nm":"Path 31","mn":"ADBE Vector Shape - Group","hd":false},{"ind":31,"ty":"sh","ix":32,"ks":{"a":0,"k":{"i":[[0,0],[-0.249,0.192],[0,0],[0.265,-0.208]],"o":[[0.247,-0.194],[0,0],[-0.266,0.205],[0,0]],"v":[[-70.391,-28.672],[-69.648,-29.251],[-74.535,-35.585],[-75.331,-34.965]],"c":true},"ix":2},"nm":"Path 32","mn":"ADBE Vector Shape - Group","hd":false},{"ind":32,"ty":"sh","ix":33,"ks":{"a":0,"k":{"i":[[0,0],[-0.247,-0.194],[0,0],[0.266,0.205]],"o":[[0.249,0.192],[0,0],[-0.265,-0.208],[0,0]],"v":[[69.648,-29.251],[70.391,-28.672],[75.331,-34.965],[74.535,-35.585]],"c":true},"ix":2},"nm":"Path 33","mn":"ADBE Vector Shape - Group","hd":false},{"ind":33,"ty":"sh","ix":34,"ks":{"a":0,"k":{"i":[[0,0],[-0.241,0.202],[0,0],[0.256,-0.218]],"o":[[0.239,-0.204],[0,0],[-0.257,0.216],[0,0]],"v":[[-74.037,-25.687],[-73.317,-26.296],[-78.463,-32.422],[-79.233,-31.77]],"c":true},"ix":2},"nm":"Path 34","mn":"ADBE Vector Shape - Group","hd":false},{"ind":34,"ty":"sh","ix":35,"ks":{"a":0,"k":{"i":[[0,0],[-0.239,-0.204],[0,0],[0.257,0.216]],"o":[[0.241,0.202],[0,0],[-0.256,-0.218],[0,0]],"v":[[73.317,-26.296],[74.037,-25.687],[79.233,-31.77],[78.463,-32.422]],"c":true},"ix":2},"nm":"Path 35","mn":"ADBE Vector Shape - Group","hd":false},{"ind":35,"ty":"sh","ix":36,"ks":{"a":0,"k":{"i":[[0,0],[-0.232,0.212],[0,0],[0.246,-0.229]],"o":[[0.23,-0.214],[0,0],[-0.248,0.227],[0,0]],"v":[[-77.555,-22.553],[-76.862,-23.191],[-82.256,-29.099],[-82.998,-28.417]],"c":true},"ix":2},"nm":"Path 36","mn":"ADBE Vector Shape - Group","hd":false},{"ind":36,"ty":"sh","ix":37,"ks":{"a":0,"k":{"i":[[0,0],[-0.23,-0.214],[0,0],[0.248,0.227]],"o":[[0.232,0.212],[0,0],[-0.246,-0.229],[0,0]],"v":[[76.862,-23.191],[77.556,-22.553],[82.998,-28.417],[82.256,-29.099]],"c":true},"ix":2},"nm":"Path 37","mn":"ADBE Vector Shape - Group","hd":false},{"ind":37,"ty":"sh","ix":38,"ks":{"a":0,"k":{"i":[[-0.111,0.111],[-0.112,0.111],[0,0],[0.119,-0.119],[0.118,-0.119],[0,0]],"o":[[0.111,-0.111],[0,0],[-0.119,0.118],[-0.119,0.119],[0,0],[0.111,-0.112]],"v":[[-80.61,-19.61],[-80.276,-19.943],[-85.909,-25.623],[-86.267,-25.267],[-86.623,-24.909],[-80.943,-19.276]],"c":true},"ix":2},"nm":"Path 38","mn":"ADBE Vector Shape - Group","hd":false},{"ind":38,"ty":"sh","ix":39,"ks":{"a":0,"k":{"i":[[0,0],[-0.111,-0.111],[-0.111,-0.112],[0,0],[0.119,0.119],[0.051,0.05],[0.069,0.068]],"o":[[0.112,0.111],[0.111,0.111],[0,0],[-0.118,-0.119],[-0.05,-0.05],[-0.069,-0.068],[0,0]],"v":[[80.276,-19.943],[80.61,-19.61],[80.943,-19.276],[86.623,-24.909],[86.267,-25.267],[86.116,-25.418],[85.909,-25.623]],"c":true},"ix":2},"nm":"Path 39","mn":"ADBE Vector Shape - Group","hd":false},{"ind":39,"ty":"sh","ix":40,"ks":{"a":0,"k":{"i":[[0,0],[-0.214,0.23],[0,0],[0.227,-0.248]],"o":[[0.212,-0.232],[0,0],[-0.229,0.246],[0,0]],"v":[[-84.191,-15.862],[-83.553,-16.556],[-89.417,-21.998],[-90.099,-21.256]],"c":true},"ix":2},"nm":"Path 40","mn":"ADBE Vector Shape - Group","hd":false},{"ind":40,"ty":"sh","ix":41,"ks":{"a":0,"k":{"i":[[0,0],[-0.212,-0.232],[0,0],[0.229,0.246]],"o":[[0.214,0.23],[0,0],[-0.227,-0.248],[0,0]],"v":[[83.553,-16.556],[84.191,-15.862],[90.099,-21.256],[89.417,-21.998]],"c":true},"ix":2},"nm":"Path 41","mn":"ADBE Vector Shape - Group","hd":false},{"ind":41,"ty":"sh","ix":42,"ks":{"a":0,"k":{"i":[[0,0],[-0.204,0.239],[0,0],[0.216,-0.257]],"o":[[0.202,-0.241],[0,0],[-0.218,0.256],[0,0]],"v":[[-87.296,-12.317],[-86.687,-13.037],[-92.77,-18.233],[-93.422,-17.463]],"c":true},"ix":2},"nm":"Path 42","mn":"ADBE Vector Shape - Group","hd":false},{"ind":42,"ty":"sh","ix":43,"ks":{"a":0,"k":{"i":[[0,0],[-0.202,-0.241],[0,0],[0.219,0.256]],"o":[[0.204,0.239],[0,0],[-0.216,-0.257],[0,0]],"v":[[86.687,-13.037],[87.296,-12.317],[93.422,-17.463],[92.77,-18.233]],"c":true},"ix":2},"nm":"Path 43","mn":"ADBE Vector Shape - Group","hd":false},{"ind":43,"ty":"sh","ix":44,"ks":{"a":0,"k":{"i":[[0,0],[-0.194,0.247],[0,0],[0.205,-0.266]],"o":[[0.192,-0.249],[0,0],[-0.208,0.265],[0,0]],"v":[[-90.251,-8.648],[-89.672,-9.391],[-95.965,-14.331],[-96.585,-13.535]],"c":true},"ix":2},"nm":"Path 44","mn":"ADBE Vector Shape - Group","hd":false},{"ind":44,"ty":"sh","ix":45,"ks":{"a":0,"k":{"i":[[0,0],[-0.192,-0.249],[0,0],[0.208,0.265]],"o":[[0.194,0.247],[0,0],[-0.205,-0.266],[0,0]],"v":[[89.672,-9.391],[90.251,-8.648],[96.585,-13.535],[95.965,-14.331]],"c":true},"ix":2},"nm":"Path 45","mn":"ADBE Vector Shape - Group","hd":false},{"ind":45,"ty":"sh","ix":46,"ks":{"a":0,"k":{"i":[[0,0],[-0.184,0.255],[0,0],[0.194,-0.274]],"o":[[0.181,-0.256],[0,0],[-0.196,0.273],[0,0]],"v":[[-93.052,-4.859],[-92.505,-5.626],[-98.996,-10.301],[-99.582,-9.48]],"c":true},"ix":2},"nm":"Path 46","mn":"ADBE Vector Shape - Group","hd":false},{"ind":46,"ty":"sh","ix":47,"ks":{"a":0,"k":{"i":[[0,0],[-0.181,-0.256],[0,0],[0.196,0.273]],"o":[[0.184,0.255],[0,0],[-0.194,-0.274],[0,0]],"v":[[92.505,-5.626],[93.052,-4.859],[99.582,-9.48],[98.996,-10.301]],"c":true},"ix":2},"nm":"Path 47","mn":"ADBE Vector Shape - Group","hd":false},{"ind":47,"ty":"sh","ix":48,"ks":{"a":0,"k":{"i":[[0,0],[-0.173,0.262],[0,0],[0.183,-0.282]],"o":[[0.171,-0.264],[0,0],[-0.185,0.281],[0,0]],"v":[[-95.694,-0.957],[-95.179,-1.746],[-101.858,-6.149],[-102.41,-5.305]],"c":true},"ix":2},"nm":"Path 48","mn":"ADBE Vector Shape - Group","hd":false},{"ind":48,"ty":"sh","ix":49,"ks":{"a":0,"k":{"i":[[0,0],[-0.171,-0.264],[0,0],[0.185,0.281]],"o":[[0.173,0.262],[0,0],[-0.183,-0.282],[0,0]],"v":[[95.179,-1.746],[95.694,-0.957],[102.41,-5.305],[101.858,-6.149]],"c":true},"ix":2},"nm":"Path 49","mn":"ADBE Vector Shape - Group","hd":false},{"ind":49,"ty":"sh","ix":50,"ks":{"a":0,"k":{"i":[[0,0],[-0.162,0.269],[0,0],[0.171,-0.29]],"o":[[0.16,-0.271],[0,0],[-0.173,0.288],[0,0]],"v":[[-98.173,3.05],[-97.69,2.241],[-104.546,-1.883],[-105.062,-1.016]],"c":true},"ix":2},"nm":"Path 50","mn":"ADBE Vector Shape - Group","hd":false},{"ind":50,"ty":"sh","ix":51,"ks":{"a":0,"k":{"i":[[0,0],[-0.16,-0.271],[0,0],[0.173,0.288]],"o":[[0.162,0.269],[0,0],[-0.171,-0.29],[0,0]],"v":[[97.69,2.241],[98.173,3.05],[105.062,-1.016],[104.546,-1.883]],"c":true},"ix":2},"nm":"Path 51","mn":"ADBE Vector Shape - Group","hd":false},{"ind":51,"ty":"sh","ix":52,"ks":{"a":0,"k":{"i":[[0,0],[-0.151,0.276],[0,0],[0.159,-0.296]],"o":[[0.148,-0.277],[0,0],[-0.161,0.295],[0,0]],"v":[[-100.484,7.157],[-100.035,6.328],[-107.055,2.492],[-107.535,3.378]],"c":true},"ix":2},"nm":"Path 52","mn":"ADBE Vector Shape - Group","hd":false},{"ind":52,"ty":"sh","ix":53,"ks":{"a":0,"k":{"i":[[0,0],[-0.148,-0.277],[0,0],[0.161,0.295]],"o":[[0.151,0.276],[0,0],[-0.159,-0.296],[0,0]],"v":[[100.035,6.328],[100.484,7.157],[107.535,3.378],[107.055,2.492]],"c":true},"ix":2},"nm":"Path 53","mn":"ADBE Vector Shape - Group","hd":false},{"ind":53,"ty":"sh","ix":54,"ks":{"a":0,"k":{"i":[[0,0],[-0.139,0.282],[0,0],[0.146,-0.303]],"o":[[0.137,-0.283],[0,0],[-0.149,0.301],[0,0]],"v":[[-102.623,11.355],[-102.209,10.509],[-109.381,6.966],[-109.824,7.872]],"c":true},"ix":2},"nm":"Path 54","mn":"ADBE Vector Shape - Group","hd":false},{"ind":54,"ty":"sh","ix":55,"ks":{"a":0,"k":{"i":[[0,0],[-0.137,-0.283],[0,0],[0.149,0.301]],"o":[[0.139,0.282],[0,0],[-0.146,-0.303],[0,0]],"v":[[102.209,10.509],[102.623,11.355],[109.824,7.872],[109.381,6.966]],"c":true},"ix":2},"nm":"Path 55","mn":"ADBE Vector Shape - Group","hd":false},{"ind":55,"ty":"sh","ix":56,"ks":{"a":0,"k":{"i":[[0,0],[-0.127,0.287],[0,0],[0.134,-0.308]],"o":[[0.125,-0.288],[0,0],[-0.136,0.307],[0,0]],"v":[[-104.587,15.639],[-104.208,14.776],[-111.521,11.532],[-111.926,12.455]],"c":true},"ix":2},"nm":"Path 56","mn":"ADBE Vector Shape - Group","hd":false},{"ind":56,"ty":"sh","ix":57,"ks":{"a":0,"k":{"i":[[0,0],[-0.125,-0.288],[0,0],[0.136,0.307]],"o":[[0.127,0.287],[0,0],[-0.134,-0.308],[0,0]],"v":[[104.208,14.776],[104.587,15.639],[111.926,12.455],[111.521,11.532]],"c":true},"ix":2},"nm":"Path 57","mn":"ADBE Vector Shape - Group","hd":false},{"ind":57,"ty":"sh","ix":58,"ks":{"a":0,"k":{"i":[[0,0],[-0.115,0.292],[0,0],[0.121,-0.314]],"o":[[0.113,-0.293],[0,0],[-0.124,0.313],[0,0]],"v":[[-106.372,19.999],[-106.029,19.121],[-113.47,16.183],[-113.836,17.122]],"c":true},"ix":2},"nm":"Path 58","mn":"ADBE Vector Shape - Group","hd":false},{"ind":58,"ty":"sh","ix":59,"ks":{"a":0,"k":{"i":[[0,0],[-0.113,-0.293],[0,0],[0.124,0.313]],"o":[[0.115,0.292],[0,0],[-0.121,-0.314],[0,0]],"v":[[106.029,19.121],[106.372,19.999],[113.836,17.122],[113.47,16.183]],"c":true},"ix":2},"nm":"Path 59","mn":"ADBE Vector Shape - Group","hd":false},{"ind":59,"ty":"sh","ix":60,"ks":{"a":0,"k":{"i":[[0,0],[-0.103,0.297],[0,0],[0.108,-0.318]],"o":[[0.101,-0.298],[0,0],[-0.11,0.318],[0,0]],"v":[[-107.975,24.43],[-107.669,23.539],[-115.225,20.91],[-115.552,21.864]],"c":true},"ix":2},"nm":"Path 60","mn":"ADBE Vector Shape - Group","hd":false},{"ind":60,"ty":"sh","ix":61,"ks":{"a":0,"k":{"i":[[0,0],[-0.101,-0.298],[0,0],[0.11,0.318]],"o":[[0.103,0.297],[0,0],[-0.108,-0.318],[0,0]],"v":[[107.669,23.539],[107.975,24.43],[115.552,21.864],[115.225,20.91]],"c":true},"ix":2},"nm":"Path 61","mn":"ADBE Vector Shape - Group","hd":false},{"ind":61,"ty":"sh","ix":62,"ks":{"a":0,"k":{"i":[[0,0],[-0.091,0.301],[0,0],[0.095,-0.323]],"o":[[0.088,-0.301],[0,0],[-0.097,0.322],[0,0]],"v":[[-109.394,28.923],[-109.126,28.02],[-116.783,25.706],[-117.071,26.672]],"c":true},"ix":2},"nm":"Path 62","mn":"ADBE Vector Shape - Group","hd":false},{"ind":62,"ty":"sh","ix":63,"ks":{"a":0,"k":{"i":[[0,0],[-0.088,-0.301],[0,0],[0.097,0.322]],"o":[[0.091,0.301],[0,0],[-0.095,-0.323],[0,0]],"v":[[109.126,28.02],[109.394,28.923],[117.071,26.672],[116.783,25.706]],"c":true},"ix":2},"nm":"Path 63","mn":"ADBE Vector Shape - Group","hd":false},{"ind":63,"ty":"sh","ix":64,"ks":{"a":0,"k":{"i":[[0,0],[-0.078,0.304],[0,0],[0.081,-0.326]],"o":[[0.076,-0.305],[0,0],[-0.084,0.326],[0,0]],"v":[[-110.627,33.472],[-110.395,32.558],[-118.142,30.562],[-118.39,31.54]],"c":true},"ix":2},"nm":"Path 64","mn":"ADBE Vector Shape - Group","hd":false},{"ind":64,"ty":"sh","ix":65,"ks":{"a":0,"k":{"i":[[0,0],[-0.076,-0.305],[0,0],[0.084,0.326]],"o":[[0.078,0.304],[0,0],[-0.081,-0.326],[0,0]],"v":[[110.395,32.558],[110.627,33.472],[118.39,31.54],[118.142,30.562]],"c":true},"ix":2},"nm":"Path 65","mn":"ADBE Vector Shape - Group","hd":false},{"ind":65,"ty":"sh","ix":66,"ks":{"a":0,"k":{"i":[[0,0],[-0.066,0.307],[0,0],[0.068,-0.329]],"o":[[0.063,-0.308],[0,0],[-0.07,0.329],[0,0]],"v":[[-111.67,38.067],[-111.476,37.144],[-119.299,35.47],[-119.506,36.457]],"c":true},"ix":2},"nm":"Path 66","mn":"ADBE Vector Shape - Group","hd":false},{"ind":66,"ty":"sh","ix":67,"ks":{"a":0,"k":{"i":[[0,0],[-0.063,-0.308],[0,0],[0.07,0.329]],"o":[[0.066,0.307],[0,0],[-0.068,-0.329],[0,0]],"v":[[111.476,37.144],[111.67,38.067],[119.506,36.457],[119.299,35.47]],"c":true},"ix":2},"nm":"Path 67","mn":"ADBE Vector Shape - Group","hd":false},{"ind":67,"ty":"sh","ix":68,"ks":{"a":0,"k":{"i":[[0,0],[-0.053,0.309],[0,0],[0.054,-0.332]],"o":[[0.05,-0.31],[0,0],[-0.057,0.331],[0,0]],"v":[[-112.522,42.701],[-112.367,41.771],[-120.252,40.422],[-120.418,41.416]],"c":true},"ix":2},"nm":"Path 68","mn":"ADBE Vector Shape - Group","hd":false},{"ind":68,"ty":"sh","ix":69,"ks":{"a":0,"k":{"i":[[0,0],[-0.05,-0.31],[0,0],[0.057,0.331]],"o":[[0.053,0.309],[0,0],[-0.054,-0.332],[0,0]],"v":[[112.367,41.771],[112.522,42.701],[120.418,41.416],[120.253,40.422]],"c":true},"ix":2},"nm":"Path 69","mn":"ADBE Vector Shape - Group","hd":false},{"ind":69,"ty":"sh","ix":70,"ks":{"a":0,"k":{"i":[[0,0],[-0.04,0.312],[0,0],[0.04,-0.334]],"o":[[0.038,-0.312],[0,0],[-0.043,0.333],[0,0]],"v":[[-113.182,47.366],[-113.066,46.431],[-121,45.409],[-121.125,46.41]],"c":true},"ix":2},"nm":"Path 70","mn":"ADBE Vector Shape - Group","hd":false},{"ind":70,"ty":"sh","ix":71,"ks":{"a":0,"k":{"i":[[0,0],[-0.038,-0.312],[0,0],[0.043,0.333]],"o":[[0.04,0.312],[0,0],[-0.04,-0.334],[0,0]],"v":[[113.066,46.431],[113.182,47.366],[121.125,46.41],[121,45.409]],"c":true},"ix":2},"nm":"Path 71","mn":"ADBE Vector Shape - Group","hd":false},{"ind":71,"ty":"sh","ix":72,"ks":{"a":0,"k":{"i":[[0,0],[-0.027,0.313],[0,0],[0.026,-0.335]],"o":[[0.025,-0.313],[0,0],[-0.029,0.335],[0,0]],"v":[[-113.649,52.055],[-113.571,51.116],[-121.541,50.422],[-121.624,51.428]],"c":true},"ix":2},"nm":"Path 72","mn":"ADBE Vector Shape - Group","hd":false},{"ind":72,"ty":"sh","ix":73,"ks":{"a":0,"k":{"i":[[0,0],[-0.025,-0.313],[0,0],[0.029,0.335]],"o":[[0.027,0.313],[0,0],[-0.026,-0.335],[0,0]],"v":[[113.571,51.116],[113.649,52.055],[121.624,51.428],[121.541,50.422]],"c":true},"ix":2},"nm":"Path 73","mn":"ADBE Vector Shape - Group","hd":false},{"ind":73,"ty":"sh","ix":74,"ks":{"a":0,"k":{"i":[[0,0],[-0.014,0.314],[0,0],[0.012,-0.336]],"o":[[0.012,-0.314],[0,0],[-0.015,0.336],[0,0]],"v":[[-113.921,56.759],[-113.882,55.818],[-121.874,55.454],[-121.916,56.462]],"c":true},"ix":2},"nm":"Path 74","mn":"ADBE Vector Shape - Group","hd":false},{"ind":74,"ty":"sh","ix":75,"ks":{"a":0,"k":{"i":[[0,0],[-0.012,-0.314],[0,0],[0.015,0.336]],"o":[[0.014,0.314],[0,0],[-0.012,-0.336],[0,0]],"v":[[113.882,55.818],[113.921,56.759],[121.916,56.462],[121.874,55.454]],"c":true},"ix":2},"nm":"Path 75","mn":"ADBE Vector Shape - Group","hd":false},{"ind":75,"ty":"sh","ix":76,"ks":{"a":0,"k":{"i":[[0,0],[-0.001,0.157],[0,0],[0,-0.168]],"o":[[0,-0.157],[0,0],[-0.001,0.168],[0,0]],"v":[[-114,61],[-113.999,60.528],[-121.999,60.495],[-122,61]],"c":true},"ix":2},"nm":"Path 76","mn":"ADBE Vector Shape - Group","hd":false},{"ind":76,"ty":"sh","ix":77,"ks":{"a":0,"k":{"i":[[0,0],[0,-0.157],[0,0],[0.001,0.168]],"o":[[0.001,0.157],[0,0],[0,-0.168],[0,0]],"v":[[113.999,60.528],[114,61],[122,61],[121.999,60.495]],"c":true},"ix":2},"nm":"Path 77","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.929411764706,0.929411764706,0.929411764706,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[500,500],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1350 (Stroke)","np":79,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":150,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Path 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[615,617.5,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[208,208],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"gs","o":{"a":0,"k":100,"ix":9},"w":{"a":0,"k":12,"ix":10},"g":{"p":5,"k":{"a":0,"k":[0,0.933,0.29,0.286,0.064,0.947,0.433,0.196,0.127,0.961,0.576,0.106,0.454,0.48,0.624,0.263,0.782,0,0.671,0.42],"ix":8}},"s":{"a":0,"k":[93,42],"ix":4},"e":{"a":0,"k":[-100,-32.5],"ix":5},"t":1,"lc":2,"lj":2,"bm":0,"nm":"Gradient Stroke 1","mn":"ADBE Vector Graphic - G-Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[500,500],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1349","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":149.166015625,"s":[50]}],"ix":2},"o":{"a":0,"k":270,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":150,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Path","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[615,617.5,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[208,208],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.96862745098,0.96862745098,0.96862745098,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":12,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[500,500],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1349","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":0,"k":50,"ix":2},"o":{"a":0,"k":270,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":150,"st":0,"ct":1,"bm":0}],"markers":[]}');
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/DebtRatio/debt-ratio.styled.ts

function debt_ratio_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > .ant-modal-content {\n    border-radius: 3px;\n  }\n\n  & .ant-modal-close-x {\n    font-size: 11px;\n  }\n\n  max-width: 400px;\n"
    ]);
    debt_ratio_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 20px 0;\n"
    ]);
    debt_ratio_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n\n  & > * {\n    margin-bottom: 16px;\n\n    &:last-child {\n      margin: 0;\n    }\n  }\n"
    ]);
    debt_ratio_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 240px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n"
    ]);
    debt_ratio_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n"
    ]);
    debt_ratio_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n  border-radius: 4px;\n  border: 1px solid #ededed;\n  width: 100%;\n  padding: 17px 16px;\n"
    ]);
    debt_ratio_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n\n  p {\n    margin: 0;\n    max-width: 50%;\n  }\n"
    ]);
    debt_ratio_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 0 16px;\n"
    ]);
    debt_ratio_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  padding: 0 6px;\n  border-radius: 8px;\n  border: 1px solid #ededed;\n  height: 18px;\n"
    ]);
    debt_ratio_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  width: 100%;\n"
    ]);
    debt_ratio_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 16px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #f2f1fe;\n"
    ]);
    debt_ratio_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var debt_ratio_styled_Modal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-1dcc3a2f-0"
})(debt_ratio_styled_templateObject());
var HeaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcc3a2f-1"
})(debt_ratio_styled_templateObject1());
var debt_ratio_styled_ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcc3a2f-2"
})(debt_ratio_styled_templateObject2());
var LottieWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcc3a2f-3"
})(debt_ratio_styled_templateObject3());
var InfoTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcc3a2f-4"
})(debt_ratio_styled_templateObject4());
var DebtRatioInfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcc3a2f-5"
})(debt_ratio_styled_templateObject5());
var RowWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcc3a2f-6"
})(debt_ratio_styled_templateObject6());
var debt_ratio_styled_DividerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcc3a2f-7"
})(debt_ratio_styled_templateObject7());
var debt_ratio_styled_SymbolChip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcc3a2f-8"
})(debt_ratio_styled_templateObject8());
var debt_ratio_styled_RowDivider = (0,styled_components_browser_esm/* default */.ZP)(divider/* default */.Z).withConfig({
    componentId: "sc-1dcc3a2f-9"
})(debt_ratio_styled_templateObject9());
var DebtRatioBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1dcc3a2f-10"
})(debt_ratio_styled_templateObject10());

;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/DebtRatio/debt-ratio.tsx











function ModalDebtRatio(param) {
    var visible = param.visible, _percentage = param.percentage, percentage = _percentage === void 0 ? 100 : _percentage, totalDebt = param.totalDebt, marketValue = param.marketValue, onCancel = param.onCancel;
    var dayTrade = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return s.dayTrade;
    });
    var ref = dayTrade || {
        debt_ratio_rules: {
            caution: 0,
            force_sell: 0
        }
    }, debtRatioRules = ref.debt_ratio_rules;
    var uiConfig = (0,common/* getDayTradeUIValue */.qD)(percentage, debtRatioRules.force_sell, debtRatioRules.caution);
    (0,react.useEffect)(function() {
        lottie_default().destroy();
        lottie_default().setQuality("high");
        var speedoAnim = lottie_default().loadAnimation({
            container: document.getElementById("debt-speedo"),
            renderer: "svg",
            loop: false,
            autoplay: true,
            animationData: speedo_portfolio_namespaceObject
        });
        var speed = percentage > 50 ? 7 : 5;
        speedoAnim.setSpeed(speed);
        var maxFrame = speedoAnim.getDuration(true);
        var minPercentage = 0;
        var maxPercentage = 100;
        var percentProgress = Math.min(Math.max(percentage, minPercentage), maxPercentage);
        if (percentProgress === minPercentage || !visible) {
            speedoAnim.goToAndStop(0, true);
            return;
        }
        if (percentProgress > debtRatioRules.force_sell) {
            speedoAnim.playSegments([
                0,
                maxFrame
            ], true);
            return;
        }
        var endFrame = percentProgress / maxPercentage * maxFrame;
        speedoAnim.playSegments([
            0,
            endFrame
        ], true);
    }, [
        visible
    ]);
    (0,react.useEffect)(function() {
        if (visible) {
            (0,securities/* clevertapDayTradeDebtRatioModalViewed */.t3)();
        }
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(debt_ratio_styled_Modal, {
        visible: visible,
        onCancel: onCancel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    align: "center",
                    family: "bold",
                    size: "18px",
                    "data-cy": "debt-ratio-modal-title",
                    children: "Debt Ratio"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(debt_ratio_styled_ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LottieWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "debt-speedo"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoTextWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "24px",
                                        family: "bold",
                                        color: uiConfig.percentColor,
                                        children: (0,formater/* formatPercentageDayTrade */.m9)(percentage)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        size: "12px",
                                        color: "#858585",
                                        children: [
                                            "Maksimal ",
                                            (0,formater/* formatPercentageDayTrade */.m9)(debtRatioRules.force_sell)
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "14px",
                        children: "Debt Ratio adalah perbandingan antara Day Trade yang sudah kamu pakai dengan market value aset Day Trade kamu saat ini."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DebtRatioInfoWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "14px",
                                        children: "Total Hutang"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "14px",
                                        children: (0,number/* formatNumber */.uf)(totalDebt)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(debt_ratio_styled_DividerWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(debt_ratio_styled_RowDivider, {
                                        dashed: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(debt_ratio_styled_SymbolChip, {
                                        children: "\xf7"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "14px",
                                        children: "Total Aset Day Trade (Market Value)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "14px",
                                        children: (0,number/* formatNumber */.uf)(marketValue)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(debt_ratio_styled_DividerWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(debt_ratio_styled_RowDivider, {
                                        dashed: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(debt_ratio_styled_SymbolChip, {
                                        children: "="
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "14px",
                                        family: "bold",
                                        children: "Debt Ratio"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "14px",
                                        family: "bold",
                                        color: uiConfig.percentColor,
                                        children: (0,formater/* formatPercentageDayTrade */.m9)(percentage)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DebtRatioBanner, {
                        children: [
                            "Aset Day Trade kamu akan terjual secara otomatis apabila Debt Ratio kamu mencapai ",
                            (0,formater/* formatPercentageDayTrade */.m9)(debtRatioRules.force_sell),
                            "."
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var debt_ratio = (/*#__PURE__*/(0,react.memo)(ModalDebtRatio));

;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/index.ts









/***/ }),

/***/ 99533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ie": function() { return /* binding */ getPortfolioType; },
/* harmony export */   "JH": function() { return /* binding */ getCombinedPortfolioList; },
/* harmony export */   "bs": function() { return /* binding */ getUnavailableReason; },
/* harmony export */   "qD": function() { return /* binding */ getDayTradeUIValue; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);



var getCombinedPortfolioList = function() {
    var dataRegular = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], dataDaytrade = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], isRealTrading = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, dataBonds = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    if (!isRealTrading) {
        return dataRegular;
    }
    var regular = (dataRegular === null || dataRegular === void 0 ? void 0 : dataRegular.map(function(item) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, item), {
            type_label: "RG"
        });
    })) || [];
    var daytrade = (dataDaytrade === null || dataDaytrade === void 0 ? void 0 : dataDaytrade.map(function(item) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, item), {
            type_label: "DT"
        });
    })) || [];
    var bonds = dataBonds === null || dataBonds === void 0 ? void 0 : dataBonds.map(function(item) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, item), {
            type_label: "FR"
        });
    });
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(daytrade).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(regular), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(bonds));
};
var getPortfolioType = function(portfolios) {
    var isRegular = portfolios === null || portfolios === void 0 ? void 0 : portfolios.some(function(item) {
        return item.type_label === "RG";
    });
    var isDayTrade = portfolios === null || portfolios === void 0 ? void 0 : portfolios.some(function(item) {
        return item.type_label === "DT";
    });
    var isBonds = portfolios === null || portfolios === void 0 ? void 0 : portfolios.some(function(item) {
        return item.type_label === "FR";
    });
    if (isRegular && isDayTrade) {
        return "Both";
    }
    if (isRegular) {
        return "Regular";
    }
    if (isDayTrade) {
        return "Day Trade";
    }
    if (isBonds) {
        return "Bonds";
    }
    return "None";
};
var getUnavailableReason = function(isTimeLimit, isSellOrder, isSellAmend, time) {
    if (!isTimeLimit || isTimeLimit && isSellAmend) {
        return "Aset Day Trade sedang dalam proses penjualan otomatis";
    }
    var orderType = isSellOrder ? "Penjualan" : "Pembelian";
    return "".concat(orderType, " saham-saham Day Trade hanya dapat dilakukan pukul ").concat(time, " WIB.");
};
var getDayTradeUIValue = function(percentRatio, forceSellLimit, cautionLimit) {
    if (percentRatio > forceSellLimit) {
        return {
            color: "#EE4A49",
            percentColor: "#EE4A49",
            background: "#FBDFDF",
            label: "FORCE SELLING"
        };
    }
    if (percentRatio > cautionLimit) {
        return {
            color: "#F5931B",
            percentColor: "#F5931B",
            background: "#FDE7CD",
            label: "CAUTION"
        };
    }
    return {
        color: "#333333",
        percentColor: "#00AB6B",
        background: "#CCEEE1",
        label: ""
    };
};


/***/ }),

/***/ 22733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wn": function() { return /* binding */ replaceWords; },
/* harmony export */   "d7": function() { return /* binding */ formatHourMinutes; },
/* harmony export */   "m9": function() { return /* binding */ formatPercentageDayTrade; }
/* harmony export */ });
/* unused harmony export replaceWord */
var formatPercentageDayTrade = function(percentage) {
    var withSymbol = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (percentage === undefined || percentage === null || Number.isNaN(percentage)) {
        return "";
    }
    return "".concat(percentage.toFixed(2)).concat(withSymbol ? "%" : "");
};
var formatHourMinutes = function() {
    var timeOpen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "00:00", timeClose = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "15:30";
    var formattedOpen = timeOpen.split(":").slice(0, 2).join(":");
    var formattedClose = timeClose.split(":").slice(0, 2).join(":");
    return {
        open: formattedOpen,
        close: formattedClose,
        openClose: "".concat(formattedOpen, " - ").concat(formattedClose)
    };
};
var replaceWord = function(words, replace, selected) {
    if (!words) {
        return "";
    }
    return words.replace(replace, selected);
};
var replaceWords = function(words, replace, selected) {
    if (!words) {
        return "";
    }
    var newWords = words;
    replace.forEach(function(item, index) {
        newWords = replaceWord(newWords, item, selected[index]);
    });
    return newWords;
};


/***/ }),

/***/ 14348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EU": function() { return /* binding */ RadioButton; },
/* harmony export */   "Ee": function() { return /* binding */ RadioGroup; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "dC": function() { return /* binding */ BoxResult; },
/* harmony export */   "xu": function() { return /* binding */ Box; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29924);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 658px;\n  margin: auto;\n  padding-bottom: 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border: solid 1px ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: solid 1px ",
        ";\n  color: ",
        ";\n  font-family: var(--bold-font);\n  font-size: 16px;\n  padding: 10px 20px;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: auto;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  width: 80px;\n  text-align: center;\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  &:first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n\n  &:last-child {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n\n  &.ant-radio-button-wrapper-checked:not([class*=' ant-radio-button-wrapper-disabled']).ant-radio-button-wrapper:first-child {\n    border-right-color: ",
        ";\n  }\n\n  &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n    color: ",
        ";\n    background: ",
        ";\n    border-color: ",
        ";\n\n    &::before {\n      background-color: ",
        ";\n    }\n\n    &:first-child {\n      border-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var AntGroup = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Group */ .ZP.Group, AntButton = antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Button */ .ZP.Button;
var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d86485cc-0"
})(_templateObject());
var Box = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    direction: "column"
}).withConfig({
    componentId: "sc-d86485cc-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro);
var BoxResult = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d86485cc-2"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dimgray */ .Z.dimgray);
var RadioGroup = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(AntGroup).withConfig({
    componentId: "sc-d86485cc-3"
})(_templateObject3());
var RadioButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(AntButton).withConfig({
    componentId: "sc-d86485cc-4"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary);


/***/ }),

/***/ 19254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32808);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  padding: 3px;\n\n  & > .ant-checkbox {\n    top: 0;\n\n    & > .ant-checkbox-inner {\n      width: 18px;\n      height: 18px;\n      border-radius: 4px;\n    }\n  }\n\n  & > .ant-checkbox-checked::after {\n    border-radius: 4px;\n  }\n\n  & > span:nth-child(2) {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-47b14e33-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ }),

/***/ 17348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  border: 1px solid #ededed;\n  color: #333333;\n\n  padding: 2px 12px;\n  border-radius: 16px;\n  width: fit-content;\n\n  text-align: center;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Chips = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-46a8463a-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Chips);


/***/ }),

/***/ 94550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CloseIconSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 12 13",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            d: "M11 1.5l-10 10M1 1.5l10 10"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseIconSvg);


/***/ }),

/***/ 48871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal_BaseSecuritiesModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 19 modules
var modal = __webpack_require__(33070);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/global/Securities/components/Icons/CloseIconSvg.tsx
var CloseIconSvg = __webpack_require__(94550);
;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/BaseSecuritiesModal/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-modal-content {\n    border-radius: 3px;\n  }\n\n  & .ant-modal-body {\n    padding: 24px 0 0;\n  }\n\n  & .ant-modal-close-x {\n    width: 50px;\n    margin-top: 6px;\n\n    :hover .anticon {\n      color: #b5b5b5;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #c1c1c1;\n  font-size: 10px;\n  transition: 0.3s color linear;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: 18px;\n  line-height: normal;\n  color: #333333;\n  margin: 0 0 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 0;\n  bottom: -16px;\n  transform: translate(0, 100%);\n  width: 100%;\n  height: unset;\n  padding: 12px 20px;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var Modal = (0,styled_components_browser_esm/* default */.ZP)(modal/* default */.Z).withConfig({
    componentId: "sc-d885cbc0-0"
})(_templateObject());
var CloseIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.Z).attrs({
    component: CloseIconSvg/* default */.Z
}).withConfig({
    componentId: "sc-d885cbc0-1"
})(_templateObject1());
var Title = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-d885cbc0-2"
})(_templateObject2());
var FloatingButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-d885cbc0-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/BaseSecuritiesModal/index.tsx





var BaseSecuritiesModal = function(_param) /*#__PURE__*/ {
    var title = _param.title, submitText = _param.submitText, onSubmit = _param.onSubmit, submitProps = _param.submitProps, hideSubmit = _param.hideSubmit, children = _param.children, _modalWidth = _param.modalWidth, modalWidth = _modalWidth === void 0 ? 500 : _modalWidth, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "submitText",
        "onSubmit",
        "submitProps",
        "hideSubmit",
        "children",
        "modalWidth"
    ]);
    return (0,jsx_runtime.jsxs)(Modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: modalWidth,
        footer: null,
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
        centered: true
    }, props), {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: title
            }),
            children,
            !hideSubmit && /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                type: "primary",
                onClick: onSubmit
            }, submitProps), {
                children: submitText
            }))
        ]
    }));
};
/* harmony default export */ var Modal_BaseSecuritiesModal = (BaseSecuritiesModal);


/***/ }),

/***/ 11806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var _api_balance__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6474);






var initialState = {
    tradingBalance: null,
    tradingLimit: null,
    dayTrade: null,
    dayTradeLeverage: null,
    dayTradeTradingBalance: null,
    isLoading: false,
    error: null
};
var useCashInfoStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        loadCashInfo: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol, orderId) {
                var axiosResponse, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                tradingBalance: 0,
                                tradingLimit: 0,
                                dayTrade: 0,
                                isLoading: true,
                                error: null
                            });
                            _ctx.next = 4;
                            return (0,_api_balance__WEBPACK_IMPORTED_MODULE_1__/* .getCashInfo */ .h)(symbol, orderId);
                        case 4:
                            axiosResponse = _ctx.sent;
                            data = axiosResponse.data.data;
                            set({
                                tradingBalance: Number(data.trade_balance),
                                tradingLimit: Number(data.trade_limit),
                                dayTrade: Number(data.day_trade_buying_power),
                                dayTradeLeverage: Number(data.day_trade_leverage),
                                dayTradeTradingBalance: Number(data.day_trade_trading_balance)
                            });
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", data);
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false,
                                error: _ctx.t0
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }));
            return function(symbol, orderId) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetCashInfo: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        set(initialState);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useCashInfoStore);


/***/ }),

/***/ 49365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_useTermsAndConditionStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware/immer.js
var immer = __webpack_require__(42435);
// EXTERNAL MODULE: ./src/lib/api/trade.ts
var trade = __webpack_require__(65141);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/global/Securities/types/termsAndCondition.ts
var termsAndCondition = __webpack_require__(13114);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/exodus.ts
var exodus = __webpack_require__(59359);
;// CONCATENATED MODULE: ./src/global/Securities/api/termsAndConditions.ts



var getTnCByFeature = function(featureId) {
    return exodus/* exodusApiInstance.withLanguageInstance */.l.withLanguageInstance(termsAndCondition/* AcceptanceLanguageEnum.BAHASA */.$6.BAHASA).get(apiEndpoint/* termsAndConditionsEndpoint.getTnCByFeature */.Lr.getTnCByFeature(featureId));
};
var postTnCAcceptance = function(featureId, version, isAccepted) {
    return exodus/* exodusApiInstance.withLanguageInstance */.l.withLanguageInstance(termsAndCondition/* AcceptanceLanguageEnum.BAHASA */.$6.BAHASA).post(apiEndpoint/* termsAndConditionsEndpoint.postTnCAcceptance */.Lr.postTnCAcceptance(), {
        acceptance_letters: [
            {
                feature_id: featureId,
                is_accepted: isAccepted,
                version: version
            }, 
        ]
    });
};
// terms and condition v2
var getTnCByFeatures = function(featureIds) {
    return exodus/* exodusApiInstance.withLanguageInstance */.l.withLanguageInstance(termsAndCondition/* AcceptanceLanguageEnum.BAHASA */.$6.BAHASA).get(apiEndpoint/* termsAndConditionsAPI.getTnCByFeature */.b4.getTnCByFeature(featureIds));
};
var postTnCAcceptances = function(acceptancePayload) {
    return exodus/* exodusApiInstance.withLanguageInstance */.l.withLanguageInstance(termsAndCondition/* AcceptanceLanguageEnum.BAHASA */.$6.BAHASA).post(apiEndpoint/* termsAndConditionsAPI.postTnCAcceptance */.b4.postTnCAcceptance(), {
        acceptance_letters: acceptancePayload
    });
};

;// CONCATENATED MODULE: ./src/global/Securities/stores/useTermsAndConditionStore.ts











var initialState = {
    contents: undefined,
    isSubmitting: false,
    termsData: undefined,
    accountStatus: ""
};
var useTermsAndConditionStore = (0,esm/* default */.ZP)((0,immer/* immer */.n)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        loadTnC: function loadTnC(featureId, onAgreementPending, onAgreementAccepted) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response, data, isAccepted;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return getTnCByFeature(featureId);
                        case 3:
                            response = _ctx.sent;
                            data = response.data.data;
                            isAccepted = data.acceptance_letters.length === 0;
                            set(function(draft) {
                                draft.contents = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, draft.contents), (0,_define_property/* default */.Z)({}, featureId, {
                                    isAccepted: isAccepted,
                                    acceptanceLetters: data.acceptance_letters
                                }));
                            });
                            if (isAccepted) {
                                _ctx.next = 10;
                                break;
                            }
                            onAgreementPending();
                            return _ctx.abrupt("return");
                        case 10:
                            onAgreementAccepted();
                            _ctx.next = 16;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }))();
        },
        postAcceptance: function postAcceptance(featureId, version) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.isSubmitting = true;
                            });
                            _ctx.next = 4;
                            return postTnCAcceptance(featureId, version, true);
                        case 4:
                            set(function(draft) {
                                draft.contents[featureId].isAccepted = true;
                                draft.isSubmitting = false;
                            });
                            _ctx.next = 11;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.contents[featureId].isAccepted = false;
                                draft.isSubmitting = false;
                            });
                            Promise.reject(_ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7
                    ]
                ]);
            }))();
        },
        loadTnCAcceptance: // terms and condition v2
        function loadTnCAcceptance(featureIds) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response, data, acceptanceLetters, isDayTradeAccepted;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return getTnCByFeatures(featureIds);
                        case 3:
                            response = _ctx.sent;
                            data = response.data.data;
                            acceptanceLetters = data.acceptance_letters;
                            acceptanceLetters.forEach(function(letter) {
                                set(function(draft) {
                                    draft.termsData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, draft.termsData), (0,_define_property/* default */.Z)({}, letter.feature_id, {
                                        isAccepted: letter.is_accepted,
                                        url: letter.url,
                                        version: letter.version
                                    }));
                                });
                                var storeKey = termsAndCondition/* TnCFeaturePersistMap */.rO[letter.feature_id];
                                useUIConfigStore/* default.getState */.Z.getState().setUIValue(storeKey, letter.is_accepted);
                            });
                            isDayTradeAccepted = useUIConfigStore/* default.getState */.Z.getState().getUIValue("dayTradeTnc");
                            return _ctx.abrupt("return", isDayTradeAccepted);
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }))();
        },
        postAcceptances: function postAcceptances(acceptances) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set(function(draft) {
                                draft.isSubmitting = true;
                            });
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return postTnCAcceptances(acceptances);
                        case 4:
                            set(function(draft) {
                                draft.isSubmitting = false;
                            });
                            return _ctx.abrupt("return", true);
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](1);
                            set(function(draft) {
                                draft.isSubmitting = false;
                            });
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 13:
                            _ctx.prev = 13;
                            set(function(draft) {
                                draft.isSubmitting = false;
                            });
                            return _ctx.finish(13);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        8,
                        13,
                        16
                    ]
                ]);
            }))();
        },
        loadSubAccountStatus: function loadSubAccountStatus(type) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response, _data, tmp, sub_account, status, isActive, storeKey;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return trade/* default.checkSubAccountDayTrade */.Z.checkSubAccountDayTrade(type);
                        case 3:
                            response = _ctx.sent;
                            _data = response.data, tmp = _data.data, sub_account = (tmp === void 0 ? {} : tmp).sub_account;
                            status = (sub_account || {}).status;
                            set(function(draft) {
                                draft.accountStatus = status;
                            });
                            isActive = status === termsAndCondition/* SubAccountStatus.ACTIVE */.go.ACTIVE;
                            storeKey = "dayTradeSubAccountActive";
                            useUIConfigStore/* default.getState */.Z.getState().setUIValue(storeKey, isActive);
                            return _ctx.abrupt("return", isActive);
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", true);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }))();
        }
    });
}));
/* harmony default export */ var stores_useTermsAndConditionStore = (useTermsAndConditionStore);


/***/ }),

/***/ 21734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ useTradingInfoStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware/immer.js
var immer = __webpack_require__(42435);
// EXTERNAL MODULE: ./src/global/Securities/types/trading.ts
var trading = __webpack_require__(6421);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var instance_trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/trading.ts




var getTradingInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(features) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,instance_trading/* getTradingApiInstance */.j)().get(apiEndpoint/* tradingEndpoints.getTradingInfo */.bU.getTradingInfo, {
                        params: {
                            features: features.join(",")
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTradingInfo(features) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/global/Securities/stores/useTradingInfoStore.ts








var initialState = {
    dayTrade: undefined,
    splitOrder: undefined,
    isLoading: false
};
var useTradingInfoStore = (0,esm/* default */.ZP)((0,immer/* immer */.n)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        loadTradingInfo: function loadTradingInfo() {
            var features = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
                trading/* TradingFeatureEnum.UNSPECIFIED */.n5.UNSPECIFIED
            ];
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.isLoading = true;
                            });
                            _ctx.next = 4;
                            return getTradingInfo(features);
                        case 4:
                            response = _ctx.sent;
                            data = response.data.data;
                            set(function(draft) {
                                draft.isLoading = false;
                                var _day_trade;
                                draft.dayTrade = (_day_trade = data.day_trade) !== null && _day_trade !== void 0 ? _day_trade : draft.dayTrade;
                                var _split_order;
                                draft.splitOrder = (_split_order = data.split_order) !== null && _split_order !== void 0 ? _split_order : draft.splitOrder;
                            });
                            return _ctx.abrupt("return", data);
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.isLoading = false;
                            });
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", {
                                day_trade: undefined,
                                split_order: undefined
                            });
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }))();
        }
    });
}));


/***/ }),

/***/ 6421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D0": function() { return /* binding */ SmartOrderLabel; },
/* harmony export */   "by": function() { return /* binding */ EventTypeEnum; },
/* harmony export */   "n5": function() { return /* binding */ TradingFeatureEnum; }
/* harmony export */ });
var TradingFeatureEnum;
(function(TradingFeatureEnum) {
    TradingFeatureEnum["UNSPECIFIED"] = "FEATURE_UNSPECIFIED";
    TradingFeatureEnum["DAY_TRADE"] = "FEATURE_DAY_TRADE";
    TradingFeatureEnum["SPLIT_ORDER"] = "FEATURE_SPLIT_ORDER";
})(TradingFeatureEnum || (TradingFeatureEnum = {}));
var EventTypeEnum;
(function(EventTypeEnum) {
    EventTypeEnum["UNSPECIFIED"] = "EVENT_TYPE_UNSPECIFIED";
    EventTypeEnum["OUTSIDE_MARKET_HOURS"] = "EVENT_TYPE_DISABLE_OUTSIDE_MARKET_HOURS";
    EventTypeEnum["EXCEED_DEBT_RATIO"] = "EVENT_TYPE_DISABLE_EXCEED_DEBT_RATIO";
})(EventTypeEnum || (EventTypeEnum = {}));
var SmartOrderLabel;
(function(SmartOrderLabel) {
    SmartOrderLabel["TP"] = "TP";
    SmartOrderLabel["SL"] = "SL";
    SmartOrderLabel["MO"] = "MO";
    SmartOrderLabel["TS"] = "TS";
    SmartOrderLabel["AB"] = "AB";
    SmartOrderLabel["BO"] = "BO";
    SmartOrderLabel["LIT_SELL"] = "LIT_SELL";
})(SmartOrderLabel || (SmartOrderLabel = {}));


/***/ })

}]);